export enum RestType {
  WEEK = 1,
  MONTH,
}
